import { isUnoIntMx } from 'app/services/tenant.service';

export const FEATURE_FLAGS = {
  SHOW_AMPLITUDE: 'showAnalyticsAmplitudeBackoffice',
  SHOW_ANALYTICS_GAME: 'showAnalyticsGameBackoffice',
  SHOW_LEMONADE_FEEDBACK_GENERATOR: 'showLemonadeFeedbackGenerator',
  SHOW_MESSAGES_GLOBAL: 'showMessagesGlobalBackoffice',
};

export function hasProgrammingTeachingLoad(organization) {
  if (organization) {
    const { tenant } = organization;
    const validTenants = ['Tangerine Lite Tenant 1', 'Santillana Integrations'];
    return validTenants.includes(tenant.name) || isUnoIntMx(organization);
  }

  return false;
}
